<template>
  <div class="container">
    <h3 class="main-title">Perfil de transacción</h3>
    <form @submit.prevent="submit" novalidate>
      <fieldset>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-66">
            <label for="monthlyAmount" :class="{'error-text': endpointErrors.monthly_amount}">Monto estimado de inversión mensual en Cumplo:</label>
          </div>
          <div class="column column-xs-100 column-sm-33">
            <money maxlength="14" v-model.trim="$v.userInteraction.monthlyAmount.$model" :class="{ 'error-label': $v.userInteraction.monthlyAmount.$error }" v-bind="money"></money>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.monthlyAmount.required">El monto es obligatorio</span>
              <span v-if="!$v.userInteraction.monthlyAmount.minValue">El monto debe de ser mayor a $0</span>
            </p>
          </div>
        </div>
        <div class="row row-responsive">
          <div class="column column-xs-100 column-sm-66">
            <label for="additionalInversion" :class="{'error-text': endpointErrors.additional_inversion}">¿Tienes intención de agregar más liquídez a tus inversiones?</label>
          </div>
          <div class="column column-xs-100 column-sm-33">
            <span class="select">
              <select v-model.trim="userInteraction.additionalInversion" :class="{ 'error-label': $v.userInteraction.additionalInversion.$error }" @change="selectadditionalInversion">
                <option value="" disabled selected>Seleccione:</option>
                <option v-for="status in selectBooleanValues" :key="status.additional" :value="status.value">
                  {{ status.additional }}
                </option>
              </select>
              <span class="arrow"></span>
            </span>
            <p class="error" v-if="errors">
              <span v-if="!$v.userInteraction.additionalInversion.required">La respuesta es obligatoria</span>
            </p>
          </div>
        </div>
        <transition name="fade">
          <div class="row row-responsive" v-if="userInteraction.additionalInversion">
            <div class="column column-xs-100 column-sm-66">
              <label for="additionalAmount" :class="{'error-text': endpointErrors.additional_amount}">Monto estimado de inversión mensual en Cumplo:</label>
            </div>
            <div class="column column-xs-100 column-sm-33">
              <money maxlength="14" v-model.trim="$v.userInteraction.additionalAmount.$model" :class="{ 'error-label': $v.userInteraction.additionalAmount.$error }" v-bind="money"></money>
              <p class="error" v-if="errors">
                <span v-if="!$v.userInteraction.additionalAmount.requiredIf">La respuesta es obligatoria</span>
                <span v-if="!$v.userInteraction.additionalAmount.minValue">El monto debe de ser mayor a $0</span>
              </p>
            </div>
          </div>
        </transition>
        <div class="row">
          <div class="column">
            <button class="button float-right" @click.prevent="submit()">Siguiente</button>
          </div>
        </div>
        <div class="row">
          <div class="column box-errors">
            <p v-if="errors" class="error">El formulario tiene errores, por favor revísalos antes de seguir.
            </p>
            <p v-else-if="empty" class="error">El formulario está vacío, todos los campos son obligatorios.
            </p>
          </div>
        </div>
      </fieldset>
    </form>
    <small>
      *Este dato es únicamente informativo y nos ayuda a conocer mejor
      el perfil de cada uno de nuestros inversionistas, por ningún motivo
      estas obligado(a) a invertir estas cantidades.
    </small>
  </div>
</template>

<script>

import Vue from 'vue'
import money from 'v-money'
import { required, minValue, requiredIf } from 'vuelidate/lib/validators'

import mixins from '@/mixins/index'
import userProfileMixin from '@/mixins/userProfileMixin'
import httpRequestMixin from '@/mixins/httpRequestMixin'

Vue.use(money)

export default {
  name: 'Step4',
  data () {
    return {
      errors: false,
      empty: false,
      endpointErrors: {
        monthly_amount: false,
        additional_inversion: false,
        additional_amount: false
      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 2,
        masked: false
      },
      selectBooleanValues: [
        {
          additional: 'Si',
          value: true
        },
        {
          additional: 'No',
          value: false
        }
      ],
      userInteraction: {
        monthlyAmount: '',
        additionalInversion: '',
        additionalAmount: ''
      }
    }
  },
  validations: {
    userInteraction: {
      monthlyAmount: { required, minValue: minValue(1.0) },
      additionalInversion: { required },
      additionalAmount: {
        requiredIf: requiredIf((obj) => {
          return obj.additionalInversion === true
        }),
        minValue: minValue(0)
      }
    }
  },
  mixins: [mixins, userProfileMixin, httpRequestMixin],
  methods: {
    selectadditionalInversion: function () {
      if (this.userInteraction.additionalInversion === false) {
        this.userInteraction.additionalAmount = 0
      }
    },
    sendDataToServer: async function () {
      await this.$store.dispatch('refreshToken')
      let options = {
        method: 'POST',
        url: process.env.AUTH_BASE + '/profile/transactionalities/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        },
        data: {
          monthly_amount: this.userInteraction.monthlyAmount,
          additional_inversion: this.userInteraction.additionalInversion,
          additional_amount: this.userInteraction.additionalAmount,
          payment_type: 1
        }
      }
      const response = await this.httpRequest(options)
      if (response) {
        switch (response.status) {
          case 200:
          case 201:
            this.nextStep()
            break
          case 202:
            this.modalError(response.data.error, 'warning')
            break
          case 400:
            this.endpointErrors.monthly_amount = ('monthly_amount' in
              response.data)
            this.endpointErrors.additional_inversion = ('additional_inversion' in
              response.data)
            this.endpointErrors.additional_amount = ('additional_amount' in
              response.data)
            break
          default:
            break
        }
      }
    },
    submit: function () {
      this.empty = !this.$v.userInteraction.$anyDirty
      this.errors = this.$v.userInteraction.$anyError

      if (this.errors === false && this.empty === false) {
        this.sendDataToServer()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/userProfile/profileSteps/StepTransaction.vue